import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {DataStorageService} from '../../shared/services/data-storage.service';
import {ActivatedRoute} from '@angular/router';
import {Subject} from 'rxjs';
import {Reservation} from '../../shared/models/reservation.model';
import {Log} from '../../shared/models/log.model';
import {takeUntil} from 'rxjs/operators';

@Component({
    templateUrl: 'overview-modal.html',
    selector: 'overview-modal'
})

export class OverviewModalComponent implements OnInit, OnDestroy {

    @Input() reservation_id: number;
    @Input() log_id: number;

    id: number;
    reservation: Reservation;
    logs: Log[] = [];

    private unsubscribe$: Subject<void> = new Subject<void>();

    constructor(private route: ActivatedRoute,
                private dataStorageService: DataStorageService) {
    }

    ngOnInit() {
        this.dataStorageService.fetchReservation(this.reservation_id)
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            reservation => {
                this.reservation = reservation;
                console.log(reservation);
            }
        );

        this.dataStorageService.fetchLogReservation(this.reservation_id)
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            logs => {
                this.logs = logs;
            }
        );
    }

    goToReservationEdit(reservation_id) {
        window.open('https://admin.ozshuttle.com/#/pages/edit-reservation/' + reservation_id, '_blank');
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
